import router from '@/router';

const OCRoutes = [
  {
    path: 'admin/shiploads',
    name: 'Shipload',
    component: {
      name: 'AdminShipload',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'shipload',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminShiploadIndex',
        component: () => import('../views/admin/ShiploadIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
      {
        path: 'new',
        name: 'AdminShiploadNew',
        component: () => import('../views/admin/ShiploadInput.vue'),
        meta: {
          action: 'new',
          backRoute: { name: 'AdminShiploadIndex' },
        },
      },
      {
        path: 'new/nob',
        name: 'nob',
        component: () => import('../views/admin/NoticeOfBerthing.vue'),
        meta: {
          action: 'new',
          customName: 'views.shipload.shipload_new_nob.new.title',
        },
      },
      {
        path: 'new/nod',
        name: 'nod',
        component: () => import('../views/admin/NoticeOfDeparture.vue'),
        meta: {
          action: 'new',
          customName: 'views.shipload.shipload_new_nod.new.title',
        },
      },
      {
        path: ':id(\\d+)',
        name: 'AdminShiploadShow',
        component: () => import('../views/admin/ShiploadShow.vue'),
        meta: {
          backRoute: {
            name: 'AdminShiploadIndex',
          },
          tArgs: route => ({ name: route?.params?.id }),
        },
        get redirect() {
          return this.children[0];
        },
        children: [
          {
            path: '',
            name: 'AdminShiploadDetails',
            component: () => import('../views/admin/ShiploadDetails.vue'),
            meta: {
              backRoute: { name: 'AdminShiploadIndex' },
            },
          },
          {
            path: 'edit',
            name: 'AdminShiploadEdit',
            component: () => import('../views/admin/ShiploadInput.vue'),
            meta: {
              action: 'edit',
              backRoute: { name: 'AdminShiploadDetails' },
            },
          },
          {
            path: 'edit/shipload_events',
            name: 'AdminShiploadEventsEdit',
            component: () => import('../views/admin/shiploadEvent/ShiploadEventsInput.vue'),
            meta: {
              action: 'edit',
              customName: 'views.shipload.shipload_events.edit.title',
              backRoute: { name: 'AdminShiploadDetails' },
            },
          },
          {
            path: 'edit/notices',
            name: 'AdminShiploadNoticesEdit',
            component: () => import('../views/admin/notice/ShiploadNoticesInput.vue'),
            meta: {
              action: 'edit',
              customName: 'views.shipload.shipload_notices_edit',
              backRoute: { name: 'AdminShiploadDetails' },
            },
          },
          {
            path: 'notices',
            name: 'AdminShiploadNotices',
            component: () => import('../views/admin/notice/ShiploadNotices.vue'),
            meta: {
              backRoute: { name: 'AdminShiploadIndex' },
              resource: 'notice',
            },
          },
          {
            path: 'attachments',
            name: 'AdminShiploadAttachments',
            component: () => import('../views/admin/attachment/ShiploadAttachments.vue'),
            meta: {
              backRoute: { name: 'AdminShiploadIndex' },
              resource: 'attachment',
            },
          },
          {
            path: 'attachments/edit',
            name: 'AdminShiploadAttachmentsEdit',
            component: () => import('../views/admin/attachment/ShiploadAttachmentsInput.vue'),
            meta: {
              backRoute: { name: 'AdminShiploadAttachments' },
              resource: 'attachment',
              action: 'edit',
            },
          },
          {
            path: 'shipload_events',
            name: 'AdminShiploadShiploadEvents',
            component: () => import('../views/admin/shiploadEvent/ShiploadShiploadEvents.vue'),
            meta: {
              backRoute: { name: 'AdminShiploadIndex' },
              resource: 'shipload_event',
              customName: 'views.shipload.statement_of_facts'
            },
          },
          {
            path: 'logs',
            name: 'AdminShiploadLogs',
            component: () => import('../views/admin/ShiploadLogs.vue'),
            meta: {
              backRoute: { name: 'AdminShiploadIndex' },
              resource: 'log',
            },
          },
        ],
      },
    ]
  },
  {
    path: 'admin/shiploads_nor_overview',
    name: 'ShiploadNorOverview',
    component: {
      name: 'AdminShipload',
      render(h) {
        return h('router-view');
      },
    },
    meta: {
      resource: 'shipload',
      customName: 'views.shipload.shipload_nor_overview.title',
    },
    get redirect() {
      return this.children[0];
    },
    children: [
      {
        path: '',
        name: 'AdminShiploadNorOverview',
        component: () => import('../views/admin/ShiploadNorOverviewIndex.vue'),
        meta: {
          backRoute: { name: 'dashboard' },
        },
      },
    ],
  },
];

OCRoutes.forEach(route => router.addRoute('OC', route));